<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="500px" persistent>
    <v-card>
      <v-card-title class="title">
        Request for Approval in Exceeding COGS cap
      </v-card-title>
      <v-card-text class="mt-3 body-2">
        <div>
          <p class="subtitle-1 font-weight-bold">Current Amount : SGD {{pairing.payoutAmount}}</p>
        </div>
        <div>
          <v-text-field
            dense
            v-model="updateData.amount"
            type="number"
            placeholder="Requested Amount"
            outlined
            @input="$v.updateData.amount.$touch()"
            :error-messages="$v.updateData.amount.$error && `Amount is required.`"
            @blur="$v.updateData.amount.$touch()"
          ></v-text-field>
        </div>
        <div>
          <v-textarea
            dense
            v-model="updateData.reasons"
            type="text"
            placeholder="Reasons"
            outlined
            @input="$v.updateData.reasons.$touch()"
            :error-messages="$v.updateData.reasons.$error && `Reasons is required.`"
            @blur="$v.updateData.reasons.$touch()"
          ></v-textarea>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="close()">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="saveReqApproval()" :disabled="$v.updateData.$invalid">Get Approval</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
  </v-dialog>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
// import userAPIs from '../User/userAPIs';
// import config from '@/config';
// import moment from 'moment'
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
export default {
  name: 'ReqCOGSApproval',
  components: {
    Loading
  },
  props: {
    value: Boolean,
    pairing: Object,
    campaignID: String,
    amount: Number,
    reasons: String,
    budget: Number,
    currentCOGS: Number,
    cogsPercent: Number
  },
  validations: {
    updateData: {
      amount: { required },
      reasons: { required }
    }
  },
  data () {
    return {
      isLoading: false,
      updateData: {
        amount: '',
        reasons: ''
      }
    }
  },
  async mounted() {
  },
  computed: {
    ...mapState({
      savedAmountApproval: state => state.pairing.savedAmountApproval
    })
  },
  watch: {
    value: function(newValue) {
      this.updateData.amount = this.amount
      this.updateData.reasons = this.reasons
      // this.updateData = {
      //   amount: '',
      //   reasons: ''
      // }
    }
    // amount: function(newValue) {
    //   this.updateData.amount = ''
    //   if (newValue) {
    //     this.updateData.amount = newValue
    //   }
    // },
    // reasons: function(newValue) {
    //   this.updateData.reasons = ''
    //   if (newValue) {
    //     this.updateData.reasons = newValue
    //   }
    // }
  },
  methods: {
    async saveReqApproval() {
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        confirmButtonText: 'Proceed',
        showCancelButton: true,
        text: `Your request will be sent to the admin for approval, please note that this campaign will be reflected as burst cogs if approved and will be evaluated during appraisal accordingly.`
      }).then(async (result) => {
        if (result.value) {
          this.isLoading = true
          let saveData = Object.assign({}, {
            pairingID: this.pairing.pairingID,
            campaignID: this.campaignID,
            budget: this.budget,
            currentCOGS: this.currentCOGS,
            cogsPercent: this.cogsPercent,
            amount: this.updateData.amount,
            reasons: this.updateData.reasons,
            status: 'pending'
          })
          await this.$store.dispatch('pairing/saveAmountApproval', saveData)
          this.isLoading = false
          if (this.savedAmountApproval) {
            this.$swal({
              text: 'Successfully Requested for Approval.',
              type: 'success'
            })
            this.$emit('saved')
            this.close()
          } else {
            this.$swal({
              text: 'Error Approval Request!',
              type: 'error'
            })
          }
        }
      })
    },
    close() {
      this.$emit('input')
    }
  }
};
</script>



// WEBPACK FOOTER //
// ReqCogsApprovalModal.vue?c7012d5c